import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import axios from 'axios';
import AppStrings from '../config/appstring'; // Replace with your actual config

function CustomTable({user}) {
  const [items, setItems] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});

  useEffect(() => {
    
console.log("Logged in as:", user?.name);
    axios.get(AppStrings.ReportHeaderList)
      .then((response) => {
        setItems(response.data.data);
      })
      .catch((error) => {
        console.error('Error fetching items:', error);
      });
  }, [user]);

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const newItems = Array.from(items);
    const [reorderedItem] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, reorderedItem);
    setItems(newItems);
  };

  const handleCheckboxChange = (id) => {
    setCheckedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const onAddClick = () => {
  const selected = items.filter((item) => checkedItems[item.SNO]);
  if (selected.length === 0) {
    alert('No students selected.');
  } else {
    const names = selected.map((s) => s.HEADERNAME || s.name).join(', ');
    alert(`Selected Students: ${names}`);
  }
};

  return (
    <div style={styles.container}>
      <h2>Customized Reports</h2>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={styles.list}
            >
              {items.map((item, index) => (
                <Draggable key={item.SNO} draggableId={item.SNO.toString()} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={{
                        ...styles.item,
                        ...provided.draggableProps.style,
                        background: snapshot.isDragging ? '#cce5ff' : '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <label style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <input
                          type="checkbox"
                          checked={checkedItems[item.SNO] || false}
                          onChange={() => handleCheckboxChange(item.SNO)}
                          style={{ marginRight: '10px' }}
                        />
                        {item.HEADERNAME || item.name}
                      </label>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <br></br>
      <div><div className="row">
       
          <div className="coolinput">
            <label className="text">Title</label>
            <input
              type="text"
              name="F_OCCUPATION"
              className="input"
            />
        
        </div>

       
      </div>
      <div className="Buttonrow">
        <div className="Bcol-25">
        <div class="coolinput">

</div>
        </div>
        <div className="Bcol-75">
        <div class="coolinput">
        <div className="Buttonrow">
  {/* First Column */}
  <div className="Bcol-25">
    <div className="coolinput">
     
    </div>
  </div>

  {/* Second Column */}
  <div className="Bcol-25">
    <div className="coolinput">
    <button onClick={onAddClick}>
      <span>Add</span>
    </button>
    </div>
  </div>

 
</div>

</div>
        </div>
      </div>
      
      </div>
    </div>
  );
}

const styles = {
  container: {
   
    width: '50vw',
  height: '85vh',
  padding: '20px',
  background: '#f8f9fa',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  },
  list: {
     background: '#e9ecef',
  padding: 10,
  borderRadius: 4,
  flex: 1,
  overflowY: 'auto',
  
  },
  item: {
    padding: 12,
    marginBottom: 8,
    backgroundColor: '#fff',
    borderRadius: 4,
    border: '1px solid #ccc',
    cursor: 'grab',
    userSelect: 'none',
  },
};

export default CustomTable;
